export default __webpack_public_path__ + "assets/images/1c5573e600fd3d2cee6f726a951d5b67.jpg";